<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 22 22"
    :fill="color"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ color }"
  >
    <path
      d="M11 22C17.0729 22 22 17.0729 22 11C22 4.92708 17.0729 0 11 0C4.92708 0 0 4.92708 0 11C0 17.0729 4.92708 22 11 22ZM10.2459 16.5C10.0327 16.5 9.8062 16.399 9.64632 16.2257L4.82316 11C4.66328 10.8268 4.58333 10.5958 4.58333 10.3504C4.58333 10.105 4.66328 9.85958 4.82316 9.68635L6.03561 8.38714C6.19549 8.21391 6.40867 8.11286 6.63517 8.11286C6.86168 8.11286 7.07485 8.21391 7.23474 8.38714L10.2459 11.6496L15.6819 5.77428C15.8418 5.60105 16.055 5.5 16.2815 5.5C16.508 5.5 16.7212 5.60105 16.8811 5.77428L18.0935 7.07349C18.2534 7.24672 18.3333 7.49213 18.3333 7.73753C18.3333 7.98294 18.2534 8.21391 18.0935 8.38714L10.8588 16.2257C10.6989 16.399 10.4724 16.5 10.2459 16.5Z"
      :fill="color"
    />
  </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'CheckfullSVG',
  props: {
    size: VueTypes.number.isRequired,
    color: VueTypes.string.isRequired,
  },
};
</script>

<style></style>
